import React, { useState } from "react";
import { Dropdown, Button, Checkbox, Divider } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { alertThresholdsConfig } from "../../Settings/AlertThresholds/AlertThresholdConfig";
import { CustomParagraph } from "../../../components";

const allRuleItems = alertThresholdsConfig.flatMap((group) => group.rules);
const allRuleIds = allRuleItems.map((rule) => rule.id);

const AlertFilterDropdown = ({ handleRFTAlertsApply }) => {
  const [selected, setSelected] = useState(allRuleIds);
  const [visible, setVisible] = useState(false); //visibility state

  const handleChange = (ruleId, isChecked) => {
    setSelected((prev) =>
      isChecked ? [...prev, ruleId] : prev.filter((id) => id !== ruleId)
    );
  };

  const handleReset = () => setSelected([]);

  const handleApply = () => {
    const selectedRules = allRuleItems.filter((rule) =>
      selected.includes(rule.id)
    );
    handleRFTAlertsApply(selected);
    setVisible(false); //Close dropdown
  };

  const dropdownContent = (
    <div className='chart-dropdown-responsive-box' >
      <CustomParagraph
        text="Uncheck alert types to exclude from data"
        fontSize={14}
        fontWeight={400}
        lineHeight="20px"
        marginBottom={16}
        color="#5e5e5e"
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
       <Checkbox
  checked={selected.length === allRuleIds.length}
  onChange={(e) => setSelected(e.target.checked ? allRuleIds : [])}
  className="alert-checkbox-custom"
>
  All alert types ({allRuleIds.length})
</Checkbox>

        <Button
          type="link"
          size="small"
          onClick={handleReset}
          style={{
            padding: 0,
            fontSize: "12px",
            color: "#000",
            fontWeight: 600,
          }}
        >
          Uncheck all
        </Button>
      </div>

      <Divider style={{ margin: "10px 0" }} />
<div style={{paddingBottom:'40px'}}>
      {alertThresholdsConfig.map(({ category, rules }) => (
        <div key={category} style={{ marginBottom: 12 }}>
          <CustomParagraph
            text={category}
            fontSize={16}
            fontWeight={600}
            lineHeight="20px"
            marginBottom={16}
            color="#000"
          />
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {rules.map((rule) => (
              <Checkbox
                key={rule.id}
                checked={selected.includes(rule.id)}
                onChange={(e) => handleChange(rule.id, e.target.checked)}
                className="alert-checkbox-custom"
              >
                {rule.title}
              </Checkbox>
            ))}
          </div>
        </div>
      ))}
</div>
<div 
style={{
  position:'absolute',
  paddingBottom:'16px',
  bottom:'0',
  width: "90%",
  backgroundColor: "#fff",

}}
>
  
      <Divider style={{ margin: "0" }} />

      <div
        style={{
          marginTop: '12px',
          display: "flex",
          justifyContent: "end",
          gap: "8px",
          width: "100%",
        }}
        >
        <Button
          type="text"
          disabled={selected.length === 0}
          onClick={handleReset}
          style={{
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "12px",
            height: "28px",
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          disabled={selected.length === 0}
          onClick={handleApply}
          style={{
            width: "58px",
            height: "28px",
            backgroundColor: selected.length === 0 ? "#afafaf" : "#000",
            borderColor: selected.length === 0 ? "#afafaf" : "#000",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "12px",
          }}
          >
          Apply
        </Button>
      </div>
          </div>
    </div>
  );

  return (
    <Dropdown
      overlay={dropdownContent}
      trigger={["click"]}
      open={visible}
      onOpenChange={setVisible}
    >
      <Button
        className="last-chart-dropdwon"
        style={{ fontWeight: "600", fontSize: "12px" }}
      >
        All alerts <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default AlertFilterDropdown;
